var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.99 11.19 15.99 16.85 20.83 19.72 21.64 18.34 17.69 16 17.69 11.19 15.99 11.19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.12,5.54A10.17,10.17,0,0,0,7,15.72H3.55L8,20.12l.08.16,4.56-4.56H9.21a7.92,7.92,0,1,1,2.32,5.59l-1.6,1.6A10.18,10.18,0,1,0,17.12,5.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarCalls);
export default __webpack_public_path__ + "static/media/toolbar-calls.82afe2ff.svg";
export { ForwardRef as ReactComponent };